import React from 'react';
import { Box, Paper, Typography, Grid, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import HistoryIcon from '@mui/icons-material/History';

const BuybackStats = () => {
  const theme  = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const border      = isDark ? '1px solid rgba(255,255,255,0.08)' : `1px solid ${theme.palette.divider}`;
  const rowBorder   = isDark ? '1px solid rgba(255,255,255,0.05)' : `1px solid ${theme.palette.divider}`;
  const headerBorder = isDark ? '1px solid rgba(255,255,255,0.07)' : `1px solid ${theme.palette.divider}`;

  const buybackData = [
    { year: '2023', ebonds: '23,300', esir: '14,300', total: '37,600' },
    { year: '2024', ebonds: '51,800', esir: '24,600', total: '76,400' },
    { year: '2025', ebonds: '69,100', esir: '26,300', total: '95,400' },
  ];

  const grandTotal = "$209,400";

  return (
    <Paper sx={{
      p: 0,
      bgcolor: 'background.paper',
      border,
      borderRadius: 0,
      overflow: 'hidden',
    }}>
      {/* Header */}
      <Box sx={{ p: 4, borderBottom: headerBorder }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 1 }}>
          <HistoryIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
          <Typography variant="caption" color="text.secondary" fontWeight={700} letterSpacing="0.1em">
            CUMULATIVE BUYBACKS
          </Typography>
        </Stack>
        <Typography variant="h3" fontWeight={700} color="text.primary" sx={{ fontFamily: '"Space Grotesk", sans-serif' }}>
          {grandTotal}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Total value returned to holders via automated protocol revenue.
        </Typography>
      </Box>

      {/* Body */}
      <Box sx={{ p: 4 }}>
        <Grid container spacing={4}>
          {/* Table header — desktop only */}
          <Grid item xs={12} sx={{ display: { xs: 'none', md: 'flex' }, pb: 2, borderBottom: rowBorder }}>
            <Grid container>
              {['FISCAL YEAR', 'EBONDS BURN', 'ESIR BURN', 'TOTAL'].map((h, i) => (
                <Grid item xs={3} key={h} textAlign={i === 3 ? 'right' : 'left'}>
                  <Typography variant="caption" color="text.secondary">{h}</Typography>
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Rows */}
          {buybackData.map((row) => (
            <Grid item xs={12} key={row.year} sx={{ borderBottom: rowBorder, pb: 2 }}>
              <Grid container alignItems="center">
                <Grid item xs={12} md={3} sx={{ mb: { xs: 1, md: 0 } }}>
                  <Typography variant="body2" fontWeight={700} color="primary.main">{row.year}</Typography>
                </Grid>
                <Grid item xs={4} md={3}>
                  <Typography variant="caption" display="block" color="text.secondary" sx={{ display: { md: 'none' } }}>EBONDS</Typography>
                  <Typography variant="body2" fontFamily="monospace" color="text.primary">${row.ebonds}</Typography>
                </Grid>
                <Grid item xs={4} md={3}>
                  <Typography variant="caption" display="block" color="text.secondary" sx={{ display: { md: 'none' } }}>ESIR</Typography>
                  <Typography variant="body2" fontFamily="monospace" color="text.primary">${row.esir}</Typography>
                </Grid>
                <Grid item xs={4} md={3} textAlign={{ xs: 'left', md: 'right' }}>
                  <Typography variant="caption" display="block" color="text.secondary" sx={{ display: { md: 'none' } }}>TOTAL</Typography>
                  <Typography variant="body2" fontWeight={700} fontFamily="monospace" color="text.primary">${row.total}</Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Paper>
  );
};

export default BuybackStats;
